import { YesNoOptions } from 'store/types'

export const yesNoOptions: { value: YesNoOptions; label: string }[] = [
  { value: '', label: 'No' },
  { value: 'true', label: 'Yes' },
]
